var _path, _rect, _rect2, _rect3, _rect4, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisketteColored(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m498.67 124.49v357.82c0 8.264-6.699 14.963-14.963 14.963h-454.02c-8.264 0-14.963-6.699-14.963-14.963v-454.02c0-8.264 6.699-14.963 14.963-14.963h357.23l111.76 111.17z",
    fill: "#221d2e"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 140.98,
    y: 13.326,
    width: 217.42,
    height: 154.3,
    fill: "#EFEFEF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 280.55,
    width: 308.6,
    height: 72.942,
    fill: "#F4A026"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 353.49,
    width: 308.6,
    height: 71.54,
    fill: "#EFEFEF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 425.03,
    width: 308.6,
    height: 72.942,
    fill: "#F4A026"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m508.22 114.55-111.58-110.82c-2.629-2.614-6.011-3.731-9.718-3.731h-357.23c-15.986 0-29.692 12.303-29.692 28.289v454.02c0 15.986 13.706 29.692 29.692 29.692h454.02c15.986 0 28.289-13.706 28.289-29.692v-357.82c0-3.733-1.138-7.312-3.783-9.945zm-164.55-86.493v126.25h-28.055v-126.25h28.055zm-56.109 0v126.25h-133.26v-126.25h133.26zm-172.54 339.46h280.55v43.485h-280.55v-43.485zm280.55-28.055h-280.55v-44.888h280.55v44.888zm-280.55 144.48v-44.888h280.55v44.888h-280.55zm368.92-1.637c0 0.516 0.282 1.637-0.234 1.637h-60.084v-204.1c0-7.746-5.58-13.326-13.326-13.326h-308.6c-7.746 0-14.729 5.58-14.729 13.326v204.1h-57.278c-0.516 0-1.637-1.121-1.637-1.637v-454.02c0-0.516 1.121-0.234 1.637-0.234h96.555v139.57c0 7.746 6.983 14.729 14.729 14.729h217.42c7.746 0 13.326-6.983 13.326-14.729v-139.57h9.403l102.82 102.27v351.98z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisketteColored);
export default __webpack_public_path__ + "static/media/DisketteColored.cfee9eab239a920318eee92d8c2f2f9c.svg";
export { ForwardRef as ReactComponent };